import {useEffect, useState} from 'react'

export const useImageIsLoading = (src: string) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const img = new Image()
    img.src = src
    img.onload = () => setIsLoading(false)
  }, [src])

  return isLoading
}
